<template>
  <w-app id="app">
    <!-- Notification -->
    <w-notification
      v-if="$page.props.flash.success"
      success
      transition="bounce"
      absolute
      plain
      round
      timeout="4000"
      @close="$page.props.flash.success = ''"
    >
      {{ $page.props.flash.success }}
    </w-notification>

    <w-notification
      v-if="$page.props.message"
      error
      transition="bounce"
      absolute
      plain
      round
      timeout="2000"
      @close="$page.props.flash.notifyerror = ''"
    >
      {{ $page.props.message }}
    </w-notification>

    <w-card class="zregbox-title">
      <br><br>
      <img src="/images/logov2.png" width="100" class="top-jata" />
      <h3>ARTIFICIAL INSEMINATION MANAGEMENT SYSTEM (AIMS)</h3>
    </w-card>

    <w-card class="zRag">
      <!-- Alerts -->
      <w-alert
        v-if="$page.props.flash.errors"
        error
        class="my0 mb2 text-light"
        transition="bounce"
        plain
        round
        no-border
        dismiss
      >
        {{ $page.props.flash.errors }}
      </w-alert>

      <w-alert
        v-if="salah"
        error
        class="my0 mb2 text-light"
        transition="bounce"
        plain
        round
        no-border
        dismiss
      >
        {{ salah }}
      </w-alert>

      <w-alert
        v-if="success"
        success
        class="my0 mb2 text-light"
        transition="bounce"
        plain
        round
        no-border
        dismiss
      >
        {{ success }}
      </w-alert>

      <!-- Form -->
      <w-form @validate="attemp">
        <center>
          <h3>PENDAFTARAN PENGGUNA BARU</h3>
        </center>
        <br><br>

        <div class="form-like-table">
          <!-- Jenis Pengguna -->
          <div class="form-row">
            <div class="label-col">Jenis Pengguna *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-radios
                v-model="form.lkp_jenis_pengguna_id"
                @input="getCapaian(2)"
                :items="jenis_pengguna"
                inline
                :validators="[validators.required]"
              />
            </div>
          </div>

          <!-- Kategori Pengguna -->
          <div class="form-row">
            <div class="label-col">Kategori Pengguna *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                v-model="form.role_id"
                :items="peran"
                @input="cekCapaian(form)"
                :validators="[validators.required]"
              />
            </div>
          </div>

          <!-- Permission (role_id == 4) -->
          <div class="form-row" v-if="form.role_id == 4">
            <div class="label-col">Kebenaran Akses *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-checkboxes
                v-model="form.permission_id"
                :items="list_permissions"
                :validators="[validators.required]"
                inline
              />
            </div>
          </div>

          <!-- Nama Penuh -->
          <div class="form-row">
            <div class="label-col">Nama Penuh *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-input
                outline
                type="text"
                placeholder="Nama Penuh"
                name="name"
                v-model="form.name"
                :disabled="!form.role_id"
                :validators="[validators.required]"
              />
              <div v-if="name_wujud" class="error-text">{{ name_wujud }}</div>
            </div>
          </div>

          <!-- Warganegara -->
          <div class="form-row" v-if="form.lkp_jenis_pengguna_id == 2">
            <div class="label-col">Warganegara *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                v-model="form.warga_negara"
                placeholder="Sila Pilih Warganegara"
                :items="[  
                  { value: 1, label: 'WARGANEGARA' },
                  { value: 2, label: 'BUKAN WARGANEGARA' },
                ]"
                :validators="[validators.required]"
              />
            </div>
          </div>

          <!-- Negara & Pasport -->
          <div v-if="form.warga_negara == 2">
            <div class="form-row">
              <div class="label-col">Negara *</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-select
                  outline
                  v-model="form.lkp_negara_id"
                  :items="negara"
                  :validators="[validators.required]"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="label-col">No. Pasport *</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-input
                  outline
                  type="text"
                  placeholder="No. Pasport"
                  v-model="form.no_id"
                  :validators="[validators.required]"
                />
                <div v-if="no_id_wujud" class="error-text">{{ no_id_wujud }}</div>
              </div>
            </div>
          </div>

          <!-- Kad Pengenalan -->
          <div v-else>
            <div class="form-row">
              <div class="label-col">No. Kad Pengenalan *</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-input
                  outline
                  type="tel"
                  placeholder="No. Kad Pengenalan"
                  v-model="form.no_id"
                  @input="acceptTypeNumber(form)"
                  :validators="[validators.required, validators.numeric]"
                />
                <div v-if="no_id_lebih_12" class="error-text">{{ no_id_lebih_12 }}</div>
                <div v-if="no_id_wujud" class="error-text">{{ no_id_wujud }}</div>
              </div>
            </div>
          </div>

          <!-- Emel -->
          <div class="form-row">
            <div class="label-col">E-mel *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-input
                outline
                type="email"
                placeholder="Sila Masukkan E-mel"
                v-model="form.email"
                :validators="[validators.required, validators.email]"
              />
              <div v-if="email_wujud" class="error-text">{{ email_wujud }}</div>
            </div>
          </div>

          <!-- Telefon -->
          <div class="form-row">
            <div class="label-col">Nombor Telefon *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-input
                outline
                type="tel"
                placeholder="Sila Masukkan Nombor Telefon"
                v-model="form.no_tel"
                :validators="[validators.required, validators.numeric]"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="label-col">Nombor Telefon Pejabat (Jika Ada)</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-input
                outline
                type="tel"
                placeholder="Sila Masukkan Nombor Telefon Pejabat"
                v-model="form.no_tel_pejabat"
              />
            </div>
          </div>

          <!-- Alamat dan lokasi -->
          <div class="form-row" v-if="form.lkp_jenis_pengguna_id == 1">
            <div class="label-col">Negeri *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                :items="negeri"
                @input="getCawangan(2)"
                v-model="form.lkp_negeri_id"
                :validators="[validators.required]"
              />
            </div>
          </div>

          <div class="form-row" v-if="form.lkp_jenis_pengguna_id == 1">
            <div class="label-col">Tempat Bertugas</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                :items="cawangan"
                @input="getAlamat()"
                v-model="form.lkp_cawangan_id"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="label-col">Alamat Surat Menyurat *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-textarea
                outline
                placeholder="Sila Masukkan Alamat"
                v-model="form.alamat"
                :validators="[validators.required]"
              />
            </div>
          </div>

          <!-- Poskod -->
          <template v-if="form.lkp_jenis_pengguna_id == 2">
          <div class="form-row">
            <div class="label-col">Poskod *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-input
                outline
                type="tel"
                placeholder="Sila Masukkan Poskod"
                v-model="form.kode"
                @change="getPoskodUtama()"
                :validators="[validators.required, validators.numeric]"
              />
            </div>
          </div>
          <div v-if="kode_tak_wujud" class="error-text">{{ kode_tak_wujud }}</div>
          </template>
          <template v-else>
          <div class="form-row">
            <div class="label-col">Poskod *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                :items="poskod"
                placeholder="Sila Masukkan Poskod"
                v-model="form.lkp_poskod_id"
                @input="getBandarPoskod()"
                :validators="[validators.required]"
                :readonly="form.lkp_jenis_pengguna_id == 1"
              />
            </div>
          </div>
          </template>

          <!-- Daerah -->
          <div class="form-row">
            <div class="label-col">Mukim/Bandar/Pekan *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                :items="bandar"
                placeholder="Sila Masukkan Mukim/Bandar/Pekan"
                v-model="form.lkp_bandar_id"
                @input="getDaerah(form, 1)"
                :validators="[validators.required]"
                :readonly="form.lkp_jenis_pengguna_id == 1"
              />
            </div>
          </div>
          <!-- Daerah -->
          <div class="form-row">
            <div class="label-col">Daerah *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                @input="getBandar(form, 1)"
                :items="lkp_daerah"
                placeholder="Sila Masukkan Daerah"
                v-model="form.lkp_daerah_id"
                :validators="[validators.required]"
                :readonly="form.lkp_jenis_pengguna_id == 1"
              />
            </div>
          </div>

          <!-- Negeri (untuk Jenis 2) -->
          <div class="form-row" v-if="form.lkp_jenis_pengguna_id == 2">
            <div class="label-col">Negeri *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                :items="negeri"
                placeholder="Sila Masukkan Negeri"
                v-model="form.lkp_negeri_id"
                @input="getBandar(1)"
                :validators="[validators.required]"
              />
            </div>
          </div>

          <!-- Role 7 & 8 -->
          <template v-if="form.role_id == 7 || form.role_id == 8">
            <div class="form-row">
            <div class="label-col">Diselia oleh Negeri *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <w-select
                outline
                :items="negeri"
                placeholder="Sila Masukkan Diselia oleh Negeri"
                v-model="form.lkp_diselia_negeri_id"
                :validators="[validators.required]"
              />
            </div>
            </div>
            <div class="form-row">
              <div class="label-col">No. Siri Kad</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-input outline type="text" placeholder="Sila Masukkan No. Siri Kad" v-model="form.no_siri" />
              </div>
            </div>

            <div class="form-row">
              <div class="label-col">Tempoh Sah Laku Sehingga *</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-input
                  outline
                  type="date"
                  v-model="form.tarikh_lantikan"
                  :validators="[validators.required]"
                />
              </div>
            </div>

            <div class="form-row" v-if="form.role_id == 7">
               <div class="label-col">Kategori Kelulusan *</div>
               <div class="separator-col">:</div>
               <div class="input-cell">
                  <w-checkboxes
                     outline
                     v-model="form.kategori_user"
                     placeholder="Sila Pilih Kategori Kelulusan"
                     :items="[  
                        { value: 1, label: 'MVC' },
                        { value: 2, label: 'Surat Lantikan' },
                     ]"
                     :validators="[validators.required]"
                  />
               </div>
            </div>
            <div class="form-row" v-if="form.kategori_user.includes(1)">
              <div class="label-col">Sijil MVC</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-input
                  type="file"
                  :preview="false"
                  accept="application/pdf"
                  v-model="files_mvc"
                  outline
                  placeholder="Sila Muat Naik Sijil MVC"
                >
                  <!-- Muat Naik Sijil Pengiktirafan DIY-AI Terkini -->
                </w-input>
                <span style="color: black;font-size: 13px;"> **Sila Muat Naik Sijil MVC</span>
              </div>
            </div>
            <div class="form-row" v-if="form.kategori_user.includes(2)">
              <div class="label-col">Sijil Lantikan</div>
              <div class="separator-col">:</div>
              <div class="input-cell">
                <w-input
                  type="file"
                  :preview="false"
                  accept="application/pdf"
                  v-model="files"
                  outline
                  placeholder="Sila Muat Naik Sijil Lantikan"
                >
                  <!-- Muat Naik Sijil Pengiktirafan DIY-AI Terkini -->
                </w-input>
                <span style="color: black;font-size: 13px;"> **Sila Muat Naik Sijil Lantikan</span>
              </div>
            </div>
          </template>

          <!-- Kata Laluan -->
          <div class="form-row">
            <div class="label-col">Kata Laluan *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <!-- <w-tooltip right align-bottom color="white" bg-color="blue">
                <template #activator="{ on }">
                  <span v-on="on">
                    <w-input
                      outline
                      placeholder="Sila Masukkan Kata Laluan"
                      :type="isPassword ? 'password' : 'text'"
                      :inner-icon-right="isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                      @click:inner-icon-right="isPassword = !isPassword"
                      v-model="form.password"
                      :validators="[validators.required]"
                    />
                  </span>
                </template>
                Medan Ini Wajib, minimum 8 aksara
              </w-tooltip> -->
              <w-tooltip
                  top
                  color="white"
                  bg-color="blue"
                  v-model="showTooltip"
                >
                  <template #activator>
                    <w-input
                      outline
                      placeholder="Sila Masukkan Kata Laluan"
                      :type="isPassword ? 'password' : 'text'"
                      :inner-icon-right="isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                      @click:inner-icon-right="isPassword = !isPassword"
                      v-model="form.password"
                      :validators="[validators.required]"
                      @focus="showFor3Sec"
                    />
                  </template>
                  Medan Ini Wajib, minimum 8 aksara
              </w-tooltip>
            </div>
          </div>

          <!-- Sahkan Kata Laluan -->
          <div class="form-row">
            <div class="label-col">Sahkan Kata Laluan *</div>
            <div class="separator-col">:</div>
            <div class="input-cell">
              <!-- <w-tooltip right align-bottom color="white" bg-color="blue">
                <template #activator="{ on }">
                  <span v-on="on">
                    <w-input
                      outline
                      placeholder="Sila Sahkan Kata Laluan"
                      :type="isPassword1 ? 'password' : 'text'"
                      :inner-icon-right="isPassword1 ? 'fal fa-eye-slash' : 'fal fa-eye'"
                      @click:inner-icon-right="isPassword1 = !isPassword1"
                      v-model="form.password_confirmation"
                      :validators="[validators.required]"
                    />
                  </span>
                </template>
                Medan Ini Wajib, minimum 8 aksara
              </w-tooltip> -->
              <w-tooltip
                  top
                  color="white"
                  bg-color="blue"
                  v-model="showTooltip2"
                >
                  <template #activator>
                    <w-input
                      outline
                      placeholder="Sila Sahkan Kata Laluan"
                      :type="isPassword1 ? 'password' : 'text'"
                      :inner-icon-right="isPassword1 ? 'fal fa-eye-slash' : 'fal fa-eye'"
                      @click:inner-icon-right="isPassword1 = !isPassword1"
                      v-model="form.password_confirmation"
                      :validators="[validators.required]"
                      @focus="showFor3Sec2"
                    />
                  </template>
                  Medan Ini Wajib, minimum 8 aksara
              </w-tooltip>
              <div v-if="form.password != form.password_confirmation" class="error-text">
                Kata Laluan tidak sepadan
              </div>
            </div>
          </div>
        </div>

        <w-flex justify-center gap="1.2" class="mt5">
            <inertia-link :href="$route('login')" class="btn-zregback">
             <w-icon class="mr2" xs>fal fa-arrow-left</w-icon> KEMBALI
           </inertia-link>
           &nbsp;
           <button type="submit" class="btn-zregbox">
             <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> DAFTAR
           </button>
         </w-flex>




      </w-form>
    </w-card>
  </w-app>
</template>



<script>
import ZResource from "@/Modules/z-resource";
import { readonly } from "vue";
// import vueRecaptcha from 'vue3-recaptcha2';

export default {
    extends: ZResource,
    props: {
        id: [Array, Object, String],
        items: [Array, Object],
    },
    components: {
    // vueRecaptcha
  },
    data() {
        return {
            isPassword: true,
            isPassword1: true,
            resourceurl: "register",
            success: "",
            error: "",
            showRecaptcha: false,
            loadingTimeout: 30000,
            negara : [],
            peran : [],
            email_wujud: "",
            jenis_pengguna : [],
            cawangan: [],
            no_id_lebih_12: "",
            no_id_wujud: "",
            kode_tak_wujud: "",
            salah: "",
            form: {
                errorsCount: 0,
                warga_negara: 0,
                cawangan: "",
                alamat: "",
                lkp_cawangan_id: "",
                jenis_pengguna_id: "",
                role_id: "",
                name: "",
                no_id: null,
                permission_id: [],
                email: "",
                no_tel: "",
                no_tel_pejabat: "",
                password: "",
                password_confirmation: "",
                kode : "",
                p : 0,
                lkp_poskod_id: "",
                lkp_bandar_id: "",
                lkp_negeri_id: "",
                lkp_negara_id: "",
                lkp_diselia_negeri_id: "",
                tarikh_lantikan: "",
                no_siri:"",
                kategori_user: "",

                // email_confirmation: "",
            },
            tabs: [
              { title: 'LAB INFORMATION', content: '' },
              { title: 'OFFICER INFORMATION', content: '' },

            ],
            poskod : [],
            bandar : [],
            negeri : [],
            negara : [],
            lkp_daerah: [],
            alamat : '',
            activeTab : 0,
            files:[],
            files_mvc:[],
            list_permissions:[
              {value: 3, label: "Penyelaras"},
              {value: 4, label: "Pegawai"},
            ],
            showTooltip: false,
            showTooltip2: false,
            }; 
        },
   methods: {
          showFor3Sec() {
            this.showTooltip = true;
            setTimeout(() => {
              this.showTooltip = false;
            }, 3000);
          },
          showFor3Sec2() {
            this.showTooltip2 = true;
            setTimeout(() => {
              this.showTooltip2 = false;
            }, 3000);
          },
         getAlamat(){
            this.$zcomm.get(this.api_service + 'lookup/alamat/'+this.form.lkp_cawangan_id, {}).then(res => {
              this.form.alamat = res.alamat
              this.form.lkp_bandar_id = res.lkp_bandar_id
              this.form.lkp_poskod_id = res.lkp_poskod_id
              this.form.lkp_daerah_id = res.lkp_daerah_id
               this.getBandar(1);
               this.getPoskod()
               this.getDaerah()
              // if (this.alamat.length > 0) {
              //  this.form.alamat = this.alamat.alamat;
              // }
            })
         },
         acceptTypeNumber(form) {
            var value = form.no_id;
            var stringValue = value.toString();
            if (stringValue.length > 12) {
               this.no_id_lebih_12 = "No. Kad Pengenalan terdiri daripada 12 digit";
              console.log('No. Kad Pengenalan ialah terdiri dari 12 angka.');
            }else{
               this.no_id_lebih_12 = '';
            }
        },
        back() {
          window.history.back();
        },

         cekCapaian(data){
            if (data.role_id == 2) {
                this.files = [];
                this.files_mvc = [];
                this.form.no_siri = '';
                this.form.tarikh_lantikan = '';
            }
         },

        getCapaian(id){
            if(this.form.role_id != null || this.form.role_id != ''){
               this.form.role_id = null;
            }
            if (id==2) {
               this.form.role_id = '';
               this.form.lkp_bandar_id = '';
               this.form.lkp_poskod_id = '';
               this.form.lkp_daerah_id = '';
               this.form.lkp_cawangan_id = '';
               this.form.poskod = '';
               this.form.lkp_negara_id='';
               this.form.alamat = '';
               this.form.warga_negara = '';
               this.form.no_siri='';
               this.form.tarikh_lantikan='';
               this.form.kategori_user = '';
            }
            this.$zcomm.get(this.api_service + 'lookup/capaian-register/'+this.form.lkp_jenis_pengguna_id, {}).then(res => {
              this.peran = res
            })
        },

        getlkpJenisPengguna(id){
            this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
              this.jenis_pengguna = res
            })
        },

         getCawangan(id){
            if(id==2){
               this.form.lkp_bandar_id == 0;
               this.form.lkp_poskod_id == 0;
               this.form.lkp_cawangan_id == 0;
               this.form.lkp_daerah_id = '';
               this.form.alamat == '';
            }
            this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form.lkp_negeri_id, {}).then(res => {
              this.cawangan = res
              this.getPoskodNegri(1);
            })
         },

         getPoskodNegri(id){
           this.$zcomm.get(this.api_service + 'lookup/poskod_negeri/'+this.form.lkp_negeri_id, {}).then(res => {
             this.poskod = res
           })
         },
        
        getNegara(){
            this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
              // this.negara = res
               this.negara = res.filter(item => item.value !== 1);
            })
        },


         getPoskodByBandar() {
           if (this.form.lkp_bandar_id) {
             this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/' + this.form.lkp_bandar_id, {}).then(res => {
               this.poskod = res;
               if (this.form.lkp_poskod_id && !this.poskod.some(item => item.value === this.form.lkp_poskod_id)) {
                 this.form.lkp_poskod_id = '';
               }
             });
           }
         },
    

        getNegeri(){
            this.form.lkp_bandar_id == '';
            this.form.lkp_poskod_id == '';
            this.form.lkp_cawangan_id == '';
            this.form.lkp_negeri_id == '';
            this.form.lkp_daerah_id = '';
            this.form.alamat == '';
            this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
              this.negeri = res
              
            })
        },

        getBandar(id){
            if(id==2){
              this.form.lkp_bandar_id == '';
            }
            this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_daerah_id, {}).then(res => {
               this.bandar = res
            })
        },

        // getBandarPoskod(id){
        //     this.form.lkp_bandar_id == '';
        //     this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/'+this.form.lkp_poskod_id, {}).then(res => {
        //        this.bandar = res
        //     })
        // },

        getBandarPoskod(id){
          console.log('Poskod dipilih:', this.form.lkp_poskod_id);
          this.form.lkp_bandar_id = '';
          
          this.$zcomm.get(this.api_service + 'lookup/bandar_poskod/'+this.form.lkp_poskod_id, {}).then(res => {
              console.log('Senarai bandar:', res);
              this.bandar = res;
              
              if (res.length === 1) {
                  console.log('Auto-pilih bandar:', res[0]);
                  this.form.lkp_bandar_id = res[0].value;
              }
          });
      },

        getPoskod(id){
            this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form.lkp_bandar_id, {}).then(res => {
              this.poskod = res
              this.form.p = id
            })
        },

        getDaerah(id){
            this.$zcomm.get(this.api_service + 'lookup/daerah/'+this.form.lkp_negeri_id, {}).then(r => {
               this.lkp_daerah = r
            })
        },

        getPoskodUtama(){
            this.kode_tak_wujud = "";
            this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
                if(res.s == 0){
                  this.poskod = [];
                  this.lkp_daerah = [];
                  this.bandar = [];
                  this.form.lkp_daerah_id = '';
                  this.form.lkp_poskod_id = '';
                  this.form.lkp_bandar_id = '';
                  this.form.lkp_negeri_id = '';
                  this.kode_tak_wujud = "Poskod tidak wujud. Sila hubungi pentadbir sistem untuk mengemaskini maklumat poskod.";
                }else if(res.lkp_bandar_id){
                  this.$zcomm.get(this.api_service + 'lookup/poskod/'+res.lkp_bandar_id, {}).then(r => {
                    this.poskod = r
                    this.form.lkp_poskod_id = res.lkp_poskod_id
                  })
                  this.$zcomm.get(this.api_service + 'lookup/daerah/'+res.lkp_negeri_id, {}).then(r => {
                    this.lkp_daerah = r
                    this.form.lkp_daerah_id = res.lkp_daerah_id
                  })
                  this.$zcomm.get(this.api_service + 'lookup/bandar/'+res.lkp_daerah_id, {}).then(r => {
                    this.bandar = r
                    this.form.lkp_bandar_id = res.lkp_bandar_id
                  })
                  this.form.lkp_negeri_id = res.lkp_negeri_id
                }
           })
            // this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
            //   // this.form.p = res.p
            //   this.form.lkp_negeri_id = res.lkp_negeri_id
            //   this.form.lkp_bandar_id = res.lkp_bandar_id
            //   this.form.lkp_poskod_id = res.lkp_poskod_id
            //   this.$zcomm.get(this.api_service + 'lookup/daerah/'+res.lkp_negeri_id, {}).then(r => {
            //       this.lkp_daerah = r
            //       this.form.lkp_daerah_id = res.lkp_daerah_id
            //    }) 
            //   this.getPoskod(0)
            //   this.getBandar(0)
            //   this.getCawangan(0)
            //   // this.getDaerah(0)
            // })
        },

        checkPoskod(){
          // alert(this.form.lkp_poskod_id);
          if(this.form.lkp_poskod_id == null){
            this.form.p = 0
          }
        },



        attemp() {
            var value = this.form.no_id;
            var stringValue = value.toString();
            console.log(stringValue.length);
            if (this.form.warga_negara==1 && (stringValue.length > 12) || ( this.form.warga_negara==1 && stringValue.length < 12)) {
               this.no_id_lebih_12 = "No. Kad Pengenalan terdiri daripada 12 digit";
               this.$zutil.notify("No. Kad Pengenalan terdiri daripada 12 digit", false);
               return;
            }
            if(this.form && this.form.role_id == 7){
              if(this.form.kategori_user && this.form.kategori_user.includes(1) && this.files_mvc.length == 0){
                this.$zutil.notify("Pastikan file mvc sudah masukan.",false
                );
                return;
              }
              if(this.form.kategori_user && this.form.kategori_user.includes(2) && this.files.length == 0){
                this.$zutil.notify("Pastikan sijil lantikan sudah masukan.",false);
                return;
              }
          }
            if (this.form.password == this.form.password_confirmation) {
               if(this.form.warga_negara == 1){
                   this.form.lkp_negara_id = 1;
                 }
              this.$zcomm.post(this.resourceurl + ".store", this.form)
                .then((res) => {
                  console.log(res);
                     if (this.form.role_id ==7||this.form.role_id==8) {
                        this.uploadMvc(res);
                        this.uploadLantikan(res);
                     }
                    // this.mapreturneddata(res);
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }                         
                    this.$zutil.notifSweet2('Pendaftaran Berjaya','Akaun anda dalam proses semakan. Sila semak inbox emel anda dari masa ke masa.', 'success');
                    this.$inertia.visit(this.$route('login'))
                })
                .catch((err) => {
                  console.log(err);
                    this.notify("Terdapat Ralat Dalam Memproses Input Anda", 0);
                      
                    if (err.response.data.errors.email == "The email has already been taken.")
                        {
                            this.email_wujud = "Emel sudah wujud";
                        }
                    if (err.response.data.errors.no_id == "The no id has already been taken.")
                        {
                            this.no_id_wujud = "No id sudah wujud";
                        }
                     if (err.response.data.errors.password == "The password must be at least 8 characters.")
                        {
                           alert('Password minimum 8 aksara')
                        }
                })

                .finally(() => {
                  this.dialog.loading = false;
                    // this.$inertia.visit(this.$route('login'))

                });
            
            }else{
               alert("Kata Laluan tidak sepadan");
            }
        },

         uploadMvc(item) 
         {  
            let formData = new FormData();
            for (var b in this.files_mvc) 
            {
                 formData.append("files["+b+"]", this.files_mvc[b].file);
            }
            formData.append("model",'\\App\\Model\\SijilMvc');
            formData.append("model_id", item.id);
            this.$zcomm.post('attahecment.upload', formData)
               .then((res) => {
                  // this.getAttahecment();
               })
               .catch((err) => {})
               .finally(() => {});
         },

         uploadLantikan(item) 
         {  
            let formData = new FormData();
            for (var b in this.files) 
            {
                 formData.append("files["+b+"]", this.files[b].file);
            }
            formData.append("model",'\\App\\Model\\SijilLantikan');
            formData.append("model_id", item.id);
            this.$zcomm.post('attahecment.upload', formData)
               .then((res) => {
                  // this.getAttahecment();
               })
               .catch((err) => {})
               .finally(() => {});
         },

         // uploadImg(item) 
         // {  
         //    let formData = new FormData();
         //    for (var b in this.files) 
         //    {
         //         formData.append("files["+b+"]", this.files[b].file);
         //    }
         //    formData.append("model",'\\App\\Model\\SijilUser');
         //    formData.append("model_id", item.id);
         //    this.$zcomm.post('attahecment.upload', formData)
         //       .then((res) => {
         //          // this.getAttahecment();
         //       })
         //       .catch((err) => {})
         //       .finally(() => {});
         // },
           
   
         notify(msg, success = true) {
              if (success) this.success = msg;
              else this.salah = msg;
            },
         },


    watch: {

    },

    mounted() {
      this.getNegeri()
      this.getNegara()
      this.getlkpJenisPengguna()
        // override default setting
        this.dialog.width = 500
          
    },

}

</script>

<style>
/* =========================================================
   LAYOUT DASAR
========================================================= */
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: "Inter", "Segoe UI", Arial, sans-serif;
  background-color: #f5f7fa;
}

/* =========================================================
   BACKGROUND UTAMA
========================================================= */
.w-app {
  background: linear-gradient(
      rgba(255, 255, 255, 0.85),
      rgba(255, 255, 255, 0.85)
    ),
    url("/images/aiibg.png") center/cover no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 20px;
}

/* =========================================================
   CARD UTAMA
========================================================= */
.zRag {
  background: #ffffffcc;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  width: 100%;
  max-width: 700px;
  padding: 30px 40px;
  animation: fadeIn 0.6s ease-in-out;
}

/* =========================================================
   HEADER CARD / TITLE
========================================================= */
.zregbox-title {
  background: linear-gradient(135deg, #0d284d, #3a6ea5);
  color: #fff;
  text-align: center;
  padding: 40px 20px 30px;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
  width: 100%;
  max-width: 700px;
}

.zregbox-title img {
  width: 160px;
  margin-bottom: 10px;
}

.zregbox-title h3 {
  margin: 0;
  font-size: 1.25rem;
  letter-spacing: 0.5px;
}

/* =========================================================
   STRUKTUR FORM
========================================================= */
.form-like-table {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.form-row {
  display: grid;
  grid-template-columns: 220px 15px 1fr;
  align-items: center;
  gap: 10px;
}

.label-col {
   font-weight: 600;
  color: #1f2937;
  white-space: normal;   /* BENARKAN WRAP */
  word-break: break-word;
  font-size: 0.95rem;
}

.separator-col {
  text-align: center;
  color: #555;
  font-weight: 500;
}

.input-cell {
  display: flex;
  flex-direction: column;
}

.error-text {
  color: #d93025;
  font-size: 0.85rem;
  margin-top: 4px;
}

/* ===============================
   Tombol utama & sekunder (kecil)
=============================== */
.btn-zregbox,
.btn-zregback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 130px;
  padding: 8px 18px;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Tombol DAFTAR (biru gradasi) */
.btn-zregbox {
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  color: #fff !important;
  border: none;
}
.btn-zregbox:hover {
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
}
.btn-zregbox:active {
  transform: scale(0.97);
}

/* Tombol KEMBALI (abu keunguan) */
.btn-zregback {
  background: #fff;
  color: #6d28d9 !important;
  border: 2px solid #c4b5fd;
  text-decoration: none;
}
.btn-zregback:hover {
  background: #ede9fe;
  border-color: #a78bfa;
  transform: translateY(-2px);
  box-shadow: 0 6px 14px rgba(167, 139, 250, 0.25);
}
.btn-zregback:active {
  transform: scale(0.97);
}

/* Responsif */
@media (max-width: 600px) {
  .btn-zregbox,
  .btn-zregback {
    min-width: 110px;
    padding: 7px 14px;
    font-size: 0.85rem;
  }
}





/* =========================================================
   RESPONSIVE
========================================================= */
@media (max-width: 700px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .separator-col {
    display: none;
  }
  .label-col {
    margin-bottom: 3px;
  }
}

@media (max-width: 600px) {
  .zRag,
  .zregbox-title {
    margin: 0 10px;
    padding: 20px;
  }

  .zregbox-title img {
    width: 160px;
  }

  .zregbox-title h3 {
    font-size: 1.1rem;
  }
}

/* =========================================================
   ANIMASI
========================================================= */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
